import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
import { FieldCol, FieldGroup, FieldLabel, FieldInput, FieldSelect, FieldTextarea, FieldDate} from '../../Elements';
import { leaseTypeDrpdwn } from '../../../../constants';
import {checkString} from '../../../../formValidator'
import { jetStreamInstance } from '../../../../lease_management/Leases';
export default class EditContributions extends Component{
  constructor(props){
    super(props);
    this.state = {
      contribution_details: {},
      error: {}
    }
  }
  componentDidMount(){
    this.updateHdState(this.props.contribution);
  }
  updateHdState = (contributions) => {
    let data = Object.assign({}, contributions);
    this.setState({
        contribution_details: data?.contribution_details
    });
  }
  updateForm = (type, value) => {
    this.setState(prevState => ({
        ...prevState,
        contribution_details: {
            ...prevState.contribution_details,
            [type]: value
        },
        error: {}
        }))
  }

  updateContributions =  (e) => {
    e.preventDefault();
    let data = Object.assign({}, this.state.contribution_details);
    this.props.updateContributions({contribution_details:data});

  }
  render(){
    const { type, portfolioList, ownerList } = this.props;
    const { error, contribution_details } = this.state;
      return(
        <form onSubmit={(e) => this.updateContributions(e)}>
          <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Component</FieldLabel>
                  <FieldInput
                    value={contribution_details?.component}
                    type={type}
                    keyParam="component"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Event</FieldLabel>
                  <FieldInput
                    value={contribution_details?.event}
                    type={type}
                    keyParam="event"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Party</FieldLabel>
                  <FieldInput
                    value={contribution_details?.party}
                    type={type}
                    keyParam="party"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Type</FieldLabel>
                  <FieldInput
                    value={contribution_details?.type}
                    type={type}
                    keyParam="type"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Reference</FieldLabel>
                  <FieldInput
                    value={contribution_details?.reference}
                    type={type}
                    keyParam="reference"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Completed</FieldLabel>
                  <FieldInput
                    value={contribution_details?.completed}
                    type={type}
                    keyParam="completed"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Partly Estimated</FieldLabel>
                  <FieldInput
                    value={contribution_details?.partly_estimated}
                    type={type}
                    keyParam="partly_estimated"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Estimated Occurence</FieldLabel>
                  <FieldInput
                    value={contribution_details?.estimated_occurence}
                    type={type}
                    keyParam="estimated_occurence"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Description</FieldLabel>
                  <FieldTextarea
                    value={contribution_details?.description}
                    type={type}
                    keyParam="description"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
         </div>
         <div className="submit-block">
           <input type="submit" className="primary-btn" value="Save Changes"/>
           <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
         </div>
       </form>
      )
  }
}
